import { apiClient, ApiResponse } from './client'

// Profile

export type GradeCode =
  | 'PRESCHOOL'
  | 'ELEM_1' | 'ELEM_2' | 'ELEM_3' | 'ELEM_4' | 'ELEM_5' | 'ELEM_6'
  | 'MIDDLE_1' | 'MIDDLE_2' | 'MIDDLE_3'
  | 'HIGH_1' | 'HIGH_2' | 'HIGH_3'

export type CharacterName = 'queda' | 'ddami' | 'chaeli'

/** 마이페이지 프로필(정체성). 출결/AIQ 상태는 별도 엔드포인트가 소유. */
export interface LearnerProfile {
  studentId: string
  name: string
  loginId: string
  birthDate: string
  grade: GradeCode | null
  schoolName: string | null
}

// 수업 기록(출결 이력)

export type AttendanceRecordStatus = 'PRESENT' | 'ABSENT' | 'LEAVE'

export interface AttendanceRecord {
  attendanceId?: number
  date: string
  status: AttendanceRecordStatus
  /** ISO with `+09:00` offset (KST). */
  checkInAt: string | null
  checkOutAt: string | null
  /** AttendanceSource — `AUTO_CLOSE` = 하원 처리 없이 자정 자동 마감. */
  source?: string
  coachingNote?: string | null
  coachingNoteVersion: number
}

export interface AttendanceHistoryPage {
  items: AttendanceRecord[]
  nextCursor: string | null
}

export const learnerProfileApi = {
  getProfile: () =>
    apiClient.get<ApiResponse<LearnerProfile>>('/lc/learner/me/profile'),

  getAttendanceHistory: (params: { cursor?: string | null; limit?: number }) =>
    apiClient.get<ApiResponse<AttendanceHistoryPage>>(
      '/lc/my/attendance/history',
      { params: { cursor: params.cursor ?? undefined, limit: params.limit ?? 30 } },
    ),
}
